import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  button: {
    height: "42px",
    minHeight: "42px",
    borderRadius: "4px",
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    gap: "6px",
    boxShadow: "none",
    backgroundColor: theme.palette.primary.main,
    padding: "10px 16px !important",
    fontFamily: theme.typography.fontFamily,
    "& .MuiButton-endIcon": {
      margin: "0 !important",
    },
  },
}));
